import Router from "@/router/router";


export default function redirect404() {
  Router.history.updateRoute(Router.match("/404/"));
}
